import { render, staticRenderFns } from "./help-composer.vue?vue&type=template&id=baee2264&scoped=true"
import script from "./help-composer.vue?vue&type=script&lang=js"
export * from "./help-composer.vue?vue&type=script&lang=js"
import style0 from "./help-composer.vue?vue&type=style&index=0&id=baee2264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee2264",
  null
  
)

export default component.exports